class HHSizekickTrigger extends HTMLElement {
  constructor() {
    super()
    this.showTooltip = this.showTooltip.bind(this)
    this.hideTooltip = this.hideTooltip.bind(this)
    this.toggleTooltip = this.toggleTooltip.bind(this)
    this.observer = null
  }
  _cacheElementSelectors() {
    this._tooltip = this.querySelector('[data-tooltip]')
    this._tooltipTrigger = this.querySelector('[data-tooltip-trigger]')
    this._closeButton = this.querySelector('[data-close-button]')
  }

  get closeButton() {
    return this._closeButton
  }

  get tooltip() {
    return this._tooltip
  }

  get tooltipTrigger() {
    return this._tooltipTrigger
  }

  connectedCallback() {
    this._cacheElementSelectors()
    this.initMutationObserver()

    document.addEventListener('sizekick:show', this.showTooltip)
    document.addEventListener('sizekick:hide', this.hideTooltip)
    this.tooltipTrigger.addEventListener('click', this.toggleTooltip)
    this.tooltipTrigger.addEventListener('focus', this.showTooltip)
    this.tooltipTrigger.addEventListener('focusout', this.hideTooltip)
    this.closeButton.addEventListener('click', this.hideTooltip)
  }

  disconnectedCallback() {
  if (this.observer) {
    this.observer.disconnect()
    this.observer = null
  }
    document.removeEventListener('sizekick:show', this.showTooltip)
    document.removeEventListener('sizekick:hide', this.hideTooltip)
    this.tooltipTrigger.removeEventListener('click', this.toggleTooltip)
    this.tooltipTrigger.removeEventListener('focus', this.showTooltip)
    this.tooltipTrigger.removeEventListener('focusout', this.hideTooltip)
    this.closeButton.removeEventListener('click', this.hideTooltip)
  }

  initMutationObserver() {
  if (document.querySelector('szk-widget-app') != null) {
    setTimeout(() => { this.classList.remove('hidden') }, 500)
    return
  }
  this.observer = new MutationObserver(() => {
    if (document.querySelector('szk-widget-app') != null) {
      setTimeout(() => { this.classList.remove('hidden') }, 500)
      this.observer.disconnect()
      this.observer = null
    }
  })
  this.observer.observe(document.body, { childList: true, subtree: true })
}

  toggleTooltip() {
    if (this.tooltip.classList.contains('active')) {
      this.hideTooltip()
    } else {
      this.showTooltip()
    }
  }

  showTooltip() {
    this.tooltip.classList.remove('closing')
    this.tooltip.classList.add('active')
    this.tooltipTrigger.setAttribute('aria-expanded', 'true')
    setTimeout(() => {
      this.hideTooltip()
    }, 5000)
  }

  hideTooltip() {
    this.tooltip.classList.add('closing')
    this.tooltipTrigger.setAttribute('aria-expanded', 'false')
    setTimeout(() => {
      this.tooltip.classList.remove('active')
      this.tooltip.classList.remove('closing')
    }, 300)
  }
}

if (!customElements.get('hh-sizekick-trigger')) {
  customElements.define('hh-sizekick-trigger', HHSizekickTrigger)
}
